import { render, staticRenderFns } from "./_modalButton.vue?vue&type=template&id=21420e9c&"
import script from "./_modalButton.vue?vue&type=script&lang=js&"
export * from "./_modalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('21420e9c', component.options)
    } else {
      api.reload('21420e9c', component.options)
    }
    module.hot.accept("./_modalButton.vue?vue&type=template&id=21420e9c&", function () {
      api.rerender('21420e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/ActionToolbar/Scripts/Buttons/_modalButton.vue"
export default component.exports